package io.jsonize.web.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.viewinterop.WebElementView
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

@OptIn(ExperimentalComposeUiApi::class)
@Composable
fun AdBanner(modifier: Modifier = Modifier) {
    WebElementView(
        factory = {
            val div = document.createElement("div") as HTMLDivElement
            div.id = "jsonize-ad"

            val ins = document.createElement("ins") as HTMLElement
            ins.className = "adsbygoogle"
            ins.setAttribute("style", "display:block; width:100%; min-height:50px;")
            ins.setAttribute("data-ad-client", "ca-pub-2274777482828095")
            ins.setAttribute("data-ad-slot", "9185613424")
            ins.setAttribute("data-ad-format", "auto")
            ins.setAttribute("data-full-width-responsive", "true")
//            ins.setAttribute("data-adtest", "on")

            div.appendChild(ins)
            div
        },
        update = {
            val ins = it.querySelector("ins.adsbygoogle") as? HTMLElement ?: return@WebElementView

            if (ins.getAttribute("data-jsonize-pushed") == "1") return@WebElementView

            fun isFilled(): Boolean {
                return ins.getAttribute("data-adsbygoogle-status") != null
            }

            fun tryPushAd(): Boolean {
                if (isFilled()) {
                    ins.setAttribute("data-jsonize-pushed", "1")
                    return true
                }
                val ads = window.asDynamic().adsbygoogle
                if (ads == null) return false
                try {
                    ins.setAttribute("data-jsonize-pushed", "1")
                    js("(adsbygoogle = window.adsbygoogle || []).push({});")
                    return true
                } catch (t: dynamic) {
                    val message = t?.message?.toString() ?: t.toString()
                    if (message.contains("already have ads", ignoreCase = true) ||
                        message.contains("All 'ins' elements", ignoreCase = true)
                    ) {
                        ins.setAttribute("data-jsonize-pushed", "1")
                        return true
                    }
                    ins.removeAttribute("data-jsonize-pushed")
                    console.warn("AdSense push failed:", t)
                }
                return false
            }

            if (ins.getAttribute("data-jsonize-retry") == "1") return@WebElementView
            ins.setAttribute("data-jsonize-retry", "1")
            var attempts = 0
            var timerId = 0
            timerId = window.setInterval({
                attempts += 1
                if (tryPushAd()) {
                    window.clearInterval(timerId)
                    ins.removeAttribute("data-jsonize-retry")
                    return@setInterval
                }
                if (attempts >= 10) {
                    window.clearInterval(timerId)
                    ins.removeAttribute("data-jsonize-retry")
                }
            }, 350)
        },
        modifier = modifier.fillMaxWidth().height(50.dp)
    )
}
